import React from "react";
import { NavLink } from "react-router-dom";
import { FaPinterest, FaStar, FaCamera, FaShieldAlt, FaGlobe } from "react-icons/fa";
import { FaRegUser } from "react-icons/fa6";
import { SlLike } from "react-icons/sl";
import { PiBuildings } from "react-icons/pi";

import Footer from "./Footer";
import background from "../about-banner.jpg";
import cityback from "../cta-bg.png";


import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
const Aboutus = () => {

const teamMembers = [
  {
    name: "Mr. Saeed Alketbi",
    position: "Founder",
    image: "Saeed.jpg",
    description: "A visionary leader in Dubai real estate, committed to top-tier service, expert guidance, and unmatched customer satisfaction.",
    socials: [
      { icon: <FaFacebookF />, link: "https://facebook.com/saeed" },
      { icon: <FaInstagram />, link: "https://instagram.com/saeed" },
      { icon: <FaLinkedinIn />, link: "https://linkedin.com/in/saeed" },
      { icon: <FaWhatsapp />, link: "https://wa.me/1234567890" },
    ],
  },
  {
    name: "Mr. Jashan Singh",
    position: "Town House Specialist",
    image: "jashan.jpg",
    description: "Leading expert in Dubai’s townhouse communities, helping clients find the perfect blend of luxury, comfort, and investment value. ",
    socials: [
      { icon: <FaFacebookF />, link: "https://www.facebook.com/share/1DRiY8jDfo/?mibextid=wwXIfr" },
      { icon: <FaInstagram />, link: "https://www.instagram.com/jashan_dxb_realtor?igsh=cTNjbmphaDh5ZHQ1&utm_source=qr" },
      { icon: <FaLinkedinIn />, link: "https://www.linkedin.com/in/jashan-singh-99815b1b7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" },
      { icon: <FaWhatsapp />, link: "https://wa.me/971582450101" },
    ],
  },
  {
    name: "Ahmad Al Mallah",
    position: "Best Deal Provider",
    image: "ahmed.jpg",
    description: "Renowned for securing top property deals in Dubai, offering the best market value on luxury villas, rentals, and investments through expert negotiation.",
    socials: [
      { icon: <FaFacebookF />, link: "https://www.facebook.com/share/1AURqt8h6z/" },
      { icon: <FaInstagram />, link: "https://www.instagram.com/skproperties_dxb?igsh=M2p4MnZqdnJuZ2hh" },
      { icon: <FaLinkedinIn />, link: "https://www.linkedin.com/in/ahmad-al-mallah-301511293?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" },
      { icon: <FaWhatsapp />, link: "https://wa.me/971552959123" },
    ],
  },
  
    {
      name: "Mr. Harpreet Singh",
      position: "Investment Specialist",
      image: "Harpreet.jpg",
      description:"Specializing in high-yield real estate investments, helping clients maximize ROI, capital appreciation, and rental income in Dubai’s market..",
      socials: [
        { icon: <FaFacebookF />, link: "https://www.facebook.com/people/Harpreet-Singh/pfbid0AZmcWvzZqPGruxxHKeKbjrB1f97EGyWrJYY14Z4WTNwXfJ9G7SozQWzPpgbGJZNMl/?mibextid=ZbWKwL" },
        { icon: <FaInstagram />, link: "https://instagram.com/harpreet" },
        { icon: <FaLinkedinIn />, link: "hhttps://www.linkedin.com/in/harpreet-singh-413584189?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_appttps://linkedin.com/in/harpreet" },
        { icon: <FaWhatsapp />, link: "https://api.whatsapp.com/send/?phone=971557289005&text&type=phone_number&app_absent=0" },
      ],
    },



];const values = [
  {
    title: "Professionalism & Expertise",
    description:
      "Delivering top-tier real estate services with unmatched expertise and professionalism.",
    icon: <FaStar />,
  },
  {
    title: "Customer Centric & Post Sales",
    description:
      "Ensuring a seamless and personalized experience, from initial inquiry to post-sale support.",
    icon: <FaCamera />,
  },
  {
    title: "Trust & Integrity",
    description:
      "Building strong, trustworthy relationships through integrity and honest communication.",
    icon: <FaShieldAlt />,
  },
  {
    title: "Transparency",
    description:
      "Maintaining complete transparency in all transactions, fostering client confidence and satisfaction.",
    icon: <FaGlobe />,
  },
];


const socialIcons = [
  { icon: <FaFacebookF />, link: "#" },
  { icon: <FaInstagram />, link: "#" },
  { icon: <FaLinkedinIn />, link: "#" },
  { icon: <FaWhatsapp />, link: "#" },
];
const stats = [
  { number: "400+", text: "Projects" },
  { number: "150+", text: "Developers" },
  { number: "120+", text: "Customers" },
  { number: "100M+", text: "AED Worth Properties Sold" },
];


return (

  <div className="mt-16 xsm:-mt-10 xsm:overflow-hidden">
    <div
      className="h-[400px] flex bg-cover  bg-center items-center justify-center relative"
      style={{ backgroundImage: `url(${background})` }}
    >
      {/* Gradient Overlay from Bottom to Top */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>

      {/* Text Content */}
      <div className="z-10 bg-black bg-opacity-25  h-full w-full flex items-center justify-center">
        <h1 className="text-5xl xsm:text-base font-bold text-white">
          About Us
        </h1>
      </div>
    </div>
    <div className="container xsm:w-full mx-auto xsm:mx-0 md:px-16 lg:px-32 xl:px-32  xsm:px-5 xsm:mt-5 xsm:py-5 mt-10 lg:py-16 xl:py-16 ">
      <div className="flex lg:flex-row  xsm:flex-col md:flex-col flex-row items-start justify-between gap-12">
        <div className="lg:w-1/2 xl:w-1/2 md:w-full xsm:w-full space-y-6 xsm:pr-0 xsm:space-y-0 pr-4">
          <h1 className="text-6xl xsm:text-base font-bold text-gray-900">
          Saeed Alketbi & Ahmad Real Estate LLC

</h1>

          <p className="text-gray-700 text-lg xsm:text-[10px] ">
          At Alketbi Real Estate LLC, we are not just real estate professionals—we are a team of industry experts dedicated to providing unparalleled real estate solutions in Dubai. Our goal is simple: to ensure every client finds the perfect property, whether for living, investing, or securing the best deal in the market.

With a strong foundation built on trust, experience, and customer satisfaction, we have established ourselves as one of Dubai’s most reputable real estate firms. Each of our founders brings a unique specialization, ensuring that clients receive expert guidance tailored to their specific needs.


          </p>

          <p className="text-gray-700 text-lg xsm:text-[10px]">
            Our dedicated team takes the time to understand each client's
            unique needs, preferences, and budget, ensuring a personalized
            experience from start to finish.
          </p>

          <p className="text-gray-700 text-lg xsm:text-[10px]">
            With an extensive portfolio of properties and a deep understanding
            of the local market, we provide expert guidance and support
            throughout the entire process, making your real estate journey
            seamless and stress- free. Your dream home is our top priority,
            and we're committed to turning your vision into reality.
          </p>

          <button className="bg-[#9A7B4F] text-white px-6 py-3 xsm:px-2 xsm:text-xs xsm:py-1 rounded-lg flex items-center space-x-2 hover:bg-blue-800 transition-colors">
            <span>JOIN US!</span>
            <span>→</span>
          </button>
        </div>

        <div className="lg:w-1/2 xl:w-1/2 md:w-full md:pl-0 xsm:w-full xsm:pl-0 lg:pl-4">
          <div className=" rounded-lg overflow-hidden">
            <img
              src="about-img-1.png"
              alt="Excited real estate team celebrating success"
              className="w-full h-full"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="py-16 xsm:py-8">
      <h2 className="text-4xl xsm:text-base font-bold text-center mb-10">
        Meet Our Founders
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-10 xsm:px-10 px-32">
        {teamMembers.map((member, index) => (
          <div key={index} className="text-center group relative">
            
            {/* Image with Hover Effect */}
            <div className="overflow-hidden rounded-lg shadow-md w-full h-[350px] relative">
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-all duration-300"
              />

              {/* Half Box with Rising Text */}
              <div className="absolute bottom-0 left-0 w-full h-1/2 bg-[#9A7B4F]  bg-opacity-80 flex flex-col items-center justify-center text-white opacity-0 translate-y-full group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
              <p className="text-xl font-extrabold text-white">{member.position}</p>

                <p className="text-sm px-4 text-center">{member.description}</p>
              </div>
            </div>

            {/* Name & Position */}
            <h3 className="mt-5 text-xl xsm:text-sm font-bold">{member.name}</h3>

            {/* Social Icons */}
            <div className="flex justify-center gap-4 mt-3">
              {member.socials?.map((social, i) => (
                <a
                  key={i}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full shadow-md bg-white hover:bg-[#9A7B4F]  hover:text-white transition-all duration-300"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="py-16 xsm:py-8 xsm:px-10 px-32 bg-[#f5f3f1]">
      <h2 className="text-4xl xsm:text-base font-bold text-center">
        Core Values
      </h2>
      <p className="text-center xsm:text-xs text-gray-600 mb-10">
      At our core, Professionalism, Integrity, and Transparency drive everything we do.

      </p>

      <div className="grid xsm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  justify-center gap-10">
        {values.map((value, index) => (
          <div
            key={index}
            className="relative hover:bg-[#9A7B4F] transition-all duration-300 hover:text-white bg-[#f4f0ef] max-w-[350px] p-6 rounded-lg shadow-lg"
          >
            <div className="flex items-center justify-center w-16 h-16 bg-white rounded-lg shadow-lg mx-auto">
              <span className="text-2xl text-black">{value.icon}</span>
            </div>
            <h3 className="mt-5 xsm:text-sm font-bold text-lg">
              {value.title}
            </h3>
            <p className=" mt-2 xsm:text-xs">{value.description}</p>
            <div className="absolute bottom-[-20px] left-[50%] translate-x-[-50%] w-6 h-6 bg-[#f4f0ef] rotate-45"></div>
          </div>
        ))}
      </div>

      {/* Dotted Timeline */}
      <div className="flex  justify-center items-center mt-10">
        <div className="flex gap-20">
          {values.map((_, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className="w-4 h-4 bg-gray-400 rounded-full"></div>
              {index < values.length && (
                <div className="w-[100px] h-[1px] bg-gray-400"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
    <div>
      {/* Top Stats Section */}
      <div className="bg-[#dcdbd2] py-20 xsm:px-10 xsm:py-8 px-32 grid xsm:grid-cols-1 md:grid-cols-4 md:gap-10 lg:grid-cols-4 text-center">
        {stats.map((item, index) => (
          <div key={index}>
            <h3 className="lg:text-5xl md:text-2xl xsm:text-base font-bold">
              {item.number}
            </h3>
            <p className="text-gray-600 lg:text-base xsm:text-xs md:text-sm">
              {item.text}
            </p>
          </div>
        ))}
      </div>

      {/* Bottom CTA Section */}
      <div className="bg-[#9A7B4F] text-white text-center py-16 relative">
        <div
          className="absolute bottom-0 left-0 right-0 opacity-90 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${cityback})`, height: "100%" }}
        ></div>
        

        <div className="relative z-10 flex lg:flex-row xsm:flex-col md:flex-col md:gap-10 md:px-10 xsm:gap-10 xsm:px-8 justify-center gap-32">
          <div className=" text-start">
            <h2 className="text-4xl xsm:text-base font-bold">
              Find Your Dream Property Today <br /> — Let’s Get Started!
            </h2>
            <p className="mt-4 text-lg text-[#d1d5db] xsm:text-xs">
              Start your real estate journey with us now and discover the
              perfect <br /> property that suits your lifestyle and budget.
            </p>
          </div>

          <div className="flex items-center justify-center">
            <button className=" bg-white  text-black px-3 py-2 text-sm font-bold  rounded-full shadow-lg hover:bg-[#f5f3f1] transition duration-300">
              FIND NOW! →
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
);
};

export default Aboutus;